import { BUFFALO_HIDDEN_VEHICLE_TYPES } from './buffalo-hidden-vehicle-types';

export const BRP_FINANCIAL_HIDDEN_VEHICLE_TYPES = BUFFALO_HIDDEN_VEHICLE_TYPES;
